import { createSlice } from "@reduxjs/toolkit";

export const AppUISlice = createSlice({
  name: "AppUI",
  initialState: {
    isLoading: true,
    sideBarOpen: false,
    currentPath: [],
    userMenu: [],
    adminMenu: [],
  },
  reducers: {
    setIsLoading(state, actions) {
      state.isLoading = actions.payload;
    },
    setSideBarOpen(state, actions) {
      state.sideBarOpen = actions.payload;
    },
    setUserMenu(state, actions) {
      state.userMenu = [...actions.payload];
    },
    setAdminMenu(state, actions) {
      state.adminMenu = [...actions.payload];
    },
    setMobileMenu(state, actions) {
      state.mobileMenu = [...actions.payload];
    },
    setCurrentPath(state, actions) {
      state.currentPath = [...actions.payload];
    },
    setActiveHC2Card(state, { payload }) {
      state.activeHC2Card = payload;
    },
  },
});

export const { setIsLoading, setSideBarOpen, setUserMenu, setAdminMenu, setMobileMenu, setCurrentPath, setActiveHC2Card } = AppUISlice.actions;

export const sideBarOpenRS = (state) => state.appUI.sideBarOpen;
export const isLoadingRS = (state) => state.appUI.isLoading;
export const userMenuRS = (state) => state.appUI.userMenu;
export const adminMenuRS = (state) => state.appUI.adminMenu;
export const mobileMenuRS = (state) => state.appUI.mobileMenu;
export const currentPathRS = (state) => state.appUI.currentPath;
export const activeHC2CardRS = (state) => state.appUI.activeHC2Card;

export default AppUISlice.reducer;
